import React from "react";
import TranslationKeys from "../../../../contexts/I18nContext/translationKeys";
import { Translate } from "../../../Translation/Translate";
import { ACCREDITATION_URL } from "../../routing-constants";
import { useNavigate } from "react-router";
import {
  AccreditationStatus,
  AccreditationStatuses,
  VerificationStatus,
  VerificationStatuses,
} from "../../../../data/types/investors";
import { WhmButton } from "@securitize/reactjs-whm";

interface AccreditationButtonProps {
  additionalAccreditation: boolean;
  accreditationStatus: AccreditationStatus;
  verificationStatus: VerificationStatus;
  currentPath: string;
}

export const AccreditationButton: React.FC<AccreditationButtonProps> = ({
  additionalAccreditation,
  currentPath,
  accreditationStatus,
  verificationStatus,
}) => {
  const navigate = useNavigate();

  return (
    <WhmButton
      onClick={() =>
        navigate(ACCREDITATION_URL(additionalAccreditation, currentPath))
      }
      variant={
        accreditationStatus === AccreditationStatuses.NONE
          ? "contained"
          : "outlined"
      }
      sx={{ marginTop: "8px" }}
      disabled={verificationStatus === VerificationStatuses.NONE}
      color="primary"
      data-test-id="profile-complete-accreditation-cta"
    >
      {accreditationStatus !== AccreditationStatuses.NONE ? (
        <Translate
          translationKey={
            TranslationKeys.PROFILE_INVESTMENT_PROFILE_ACCREDITATION_CARD_CTA_VIEW
          }
        />
      ) : (
        <Translate
          translationKey={
            TranslationKeys.PROFILE_INVESTMENT_PROFILE_ACCREDITATION_CARD_CTA_COMPLETE
          }
        />
      )}
    </WhmButton>
  );
};
